export enum CookieType {
  LANGUAGE = 'language',
  CURRENCY = 'currency',
  LOCATION_CURRENCY = 'locationCurrency',
  COUNTRY = 'country',
  SESSION_ID = 'sc_session_id',
  SEARCH_STAYCITY = 'staycitySearches',
  SEARCH_WILDE = 'wildeSearches'
}
export enum Tracking {
  PAGE_VIEW = 'page_view',
  TRACK_EVENT = 'track_event',
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  NEWSLETTER_SIGNUP = 'newsletter_signup',
  MEMBER_LOGIN_OVERLAY = 'member_login',
  MEMBER_RESET_OVERLAY = 'member_reset',
  MEMBER_REGISTER_OVERLAY = 'member_register',
  OPEN_REVIEWS_OVERLAY = 'open_reviews',
  OPEN_EDIT_GUEST_DETAILS = 'open_guest_details',
  OPEN_CANCEL_BOOKING = 'open_cancel_booking',
  SHOW_IF_CAPS_INVALID = 'show_if_caps_invalid_keyboard_event',
  SEARCH_BAR_MANIFEST_LOAD_FAIL = 'searchbar_failed_fetch_manifest',
  SEARCH_BAR_MANIFEST_PARSE_FAIL = 'searchbar_failed_parse_manifest',
  SEARCH_BAR_MANIFEST_ASSET_LOAD_FAIL = 'searchbar_failed_manifest_asset_load'
}
export enum GalleryPage {
  GRID = 'grid',
  CAROUSEL = 'carousel'
}
export enum CurrencyValues {
  GBP = 'gbp',
  EUR = 'eur',
  USD = 'usd'
}
